module.exports = __webpack_public_path__ + "img/title4.c7513396.png";